import classNames from 'classnames'
import type { IconsProps } from '@winnin/winnin_ui.components.icon'
import { Icon } from '@winnin/winnin_ui.components.icon'

import './styles.scss'

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconsProps['icon'] | JSX.Element
  /** @default 20 */
  size?: number
  color?: string
  /** @default 4 */
  padding?: number
}

export default function IconButton({
  icon,
  size = 20,
  color,
  className,
  style,
  padding = 4,
  ...props
}: IconButtonProps) {
  return (
    <button className={classNames('IconButton', className)} style={{ color, padding, ...style }} {...props}>
      {typeof icon === 'string' ? <Icon icon={icon as IconsProps['icon']} width={size} height={size} /> : icon}
    </button>
  )
}
